module.exports = __webpack_public_path__ + "img/01.07068572.webp";